/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response to a direct booking cancel request
 * @export
 * @interface DirectBookingCancelResponse
 */
export interface DirectBookingCancelResponse {
    /**
     * 
     * @type {string}
     * @memberof DirectBookingCancelResponse
     */
    status: DirectBookingCancelResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DirectBookingCancelResponse
     */
    celeryTaskId: string;
}


/**
 * @export
 */
export const DirectBookingCancelResponseStatusEnum = {
    Pending: 'PENDING',
    Success: 'SUCCESS',
    Error: 'ERROR'
} as const;
export type DirectBookingCancelResponseStatusEnum = typeof DirectBookingCancelResponseStatusEnum[keyof typeof DirectBookingCancelResponseStatusEnum];


/**
 * Check if a given object implements the DirectBookingCancelResponse interface.
 */
export function instanceOfDirectBookingCancelResponse(value: object): value is DirectBookingCancelResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('celeryTaskId' in value) || value['celeryTaskId'] === undefined) return false;
    return true;
}

export function DirectBookingCancelResponseFromJSON(json: any): DirectBookingCancelResponse {
    return DirectBookingCancelResponseFromJSONTyped(json, false);
}

export function DirectBookingCancelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DirectBookingCancelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'celeryTaskId': json['celery_task_id'],
    };
}

export function DirectBookingCancelResponseToJSON(json: any): DirectBookingCancelResponse {
    return DirectBookingCancelResponseToJSONTyped(json, false);
}

export function DirectBookingCancelResponseToJSONTyped(value?: DirectBookingCancelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'celery_task_id': value['celeryTaskId'],
    };
}

